import React from 'react';
import '../assets/styles/Loader.css'; 
import logo from '../assets/icono.png'; 
const Loader = () => {
  return (
    <div className="loader-overlay">
      <img src={logo} className="spinning-logo" alt="Cargando..." />
    </div>
  );
};

export default Loader;